import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckMark from "./images/check.png";
import XMark from "./images/x.png";
import GridPattern from "./GridPattern";
import TLBlur from "./images/tl-blur.jpg";
import TRBlur from "./images/tr-blur.jpg";

const ExchangePage = ({ data, loading, strapiUrl }) => {
  const navigate = useNavigate();
  const { exchange } = useParams();

  const [exchangedata, setExchangeData] = useState({
    attributes: {
      name: "Exchange Name",
      ecash_brand: true,
      decimal_places: 0,
      score: 0,
      ecash_deposit_address_format: true,
      ecash_website_link: true,
      url: "/",
      deposits_working: true,
      withdrawals_working: true,
      withdrawal_fee: 10,
      trading_pairs: ["USDT"],
      logo: { data: { attributes: { url: "" } } },
    },
  });

  useEffect(() => {
    if (!data || !Array.isArray(data) || data.length === 0 || loading) {
      return;
    }

    const Filter = (data) => {
      const result = data.filter(
        (item) =>
          item.attributes.name
            .toLowerCase()
            .replace(/\s/g, "-")
            .replace(/\./g, "-") === exchange
      );
      return result[0];
    };

    const filtered = Filter(data);
    if (filtered) {
      setExchangeData(filtered);
    }
  }, [data, exchange, loading]);

  const CheckTrue = ({ type, item }) => {
    if (type === "decimal") {
      return <>{item === 2 ? item : item !== null ? item : <Unsure />}</>;
    } else if (type === "deposit_confirmations") {
      return (
        <>
          {item <= 1 && item !== null ? (
            item
          ) : item !== null ? (
            item
          ) : (
            <Unsure />
          )}
        </>
      );
    } else if (type === "trading_pairs") {
      return <>{item.length}</>;
    } else if (type === "withdrawal_fee") {
      return (
        <>
          {item <= 100 && item !== null ? (
            <Check />
          ) : item !== null ? (
            <X />
          ) : (
            <Unsure />
          )}
        </>
      );
    } else
      return (
        <>
          {item && item !== null ? (
            <Check />
          ) : item !== null ? (
            <X />
          ) : (
            <Unsure />
          )}
        </>
      );
  };

  const CheckTrueStyle = ({ type, item }) => {
    if (type === "decimal") {
      return item === 2 ? "blue" : item !== null ? "black" : "gray";
    } else if (type === "deposit_confirmations") {
      return item === null || item === undefined
        ? "gray"
        : item > 1
        ? "red"
        : item === 1
        ? "black"
        : "blue";
    } else if (type === "withdrawal_fee") {
      return item <= 100 && item !== null
        ? "blue"
        : item <= 1000 && item !== null
        ? "black"
        : item === null || typeof item === "string"
        ? "gray"
        : "red";
    } else if (type === "trading_pairs") {
      return item.length >= 2 && item !== null ? "blue" : "black";
    } else
      return item && item !== null ? "blue" : item !== null ? "red" : "gray";
  };

  const Check = () => {
    return <img src={CheckMark} alt="Yes" />;
  };

  const X = () => {
    return <img src={XMark} alt="No" />;
  };

  const Unsure = () => {
    return "?";
  };

  const DetailsRow = ({ type, item, title }) => {
    return (
      <div className={`detail-row ${CheckTrueStyle({ type, item })}`}>
        <div className="detail-row-checkbox">
          <CheckTrue type={type} item={item} />
        </div>
        <div className="detail-row-divider" />
        <h3>{title}</h3>
      </div>
    );
  };

  return (
    <>
      <div className="list-ctn">
        <GridPattern
          className="grid-pattern-left"
          style={{
            top: "150px",
            left: "50px",
          }}
        />
        <GridPattern
          className="grid-pattern-right"
          style={{
            top: "450px",
            right: "50px",
          }}
        />
        <img src={TLBlur} alt="eCash" className="tl-blur" />
        <img src={TRBlur} alt="eCash" className="tr-blur" />
        <div className="list-ctn-inner">
          {loading && <div>Loading...</div>}
          {!loading && (
            <>
              <div className="details-ctn">
                <div className="logo-score-ctn">
                  {exchangedata.attributes.url !== null ? (
                    <a
                      href={exchangedata.attributes.url}
                      target="_blank"
                      rel="noreferrer"
                      className="exchange-detail-img"
                    >
                      <img
                        src={
                          strapiUrl +
                          exchangedata.attributes.logo.data.attributes.url
                        }
                        alt={exchangedata.attributes.name}
                      />
                    </a>
                  ) : (
                    <div className="exchange-detail-img">
                      <img
                        src={
                          strapiUrl +
                          exchangedata.attributes.logo.data.attributes.url
                        }
                        alt={exchangedata.attributes.name}
                      />
                    </div>
                  )}
                </div>

                {/********************************** WITHDRAWALS *****************************************/}

                <DetailsRow
                  item={exchangedata.attributes.withdrawals_working}
                  title="Withdrawals Working"
                />
                {exchangedata.attributes.withdrawals_working === false && (
                  <div className="error-row">
                    Users need to be able to withdraw their eCash.
                  </div>
                )}
                {exchangedata.attributes.withdrawals_working === null && (
                  <div className="error-row-undefined">
                    Users need to be able to withdraw their eCash.
                  </div>
                )}

                {/********************************** DEPOSITS *****************************************/}

                <DetailsRow
                  item={exchangedata.attributes.deposits_working}
                  title="Deposits Working"
                />
                {exchangedata.attributes.deposits_working === false && (
                  <div className="error-row">
                    Users need to be able to deposit eCash.
                  </div>
                )}
                {exchangedata.attributes.deposits_working === null && (
                  <div className="error-row-undefined">
                    Users need to be able to deposit eCash.
                  </div>
                )}

                {/********************************** ADDRESS *****************************************/}

                <DetailsRow
                  item={exchangedata.attributes.ecash_deposit_address_format}
                  title="eCash address format"
                />
                {exchangedata.attributes.ecash_deposit_address_format ===
                  false && (
                  <div className="error-row">
                    Addresses need to be using the eCash address format
                    (ecash:XXX).
                  </div>
                )}
                {exchangedata.attributes.ecash_deposit_address_format ===
                  null && (
                  <div className="error-row-undefined">
                    Addresses need to be using the eCash address format
                    (ecash:XXX).
                  </div>
                )}

                {/********************************** CONFIRMATIONS *****************************************/}

                <DetailsRow
                  type="deposit_confirmations"
                  item={exchangedata.attributes.deposit_confirmations}
                  title={`Deposit Confirmation${
                    exchangedata.attributes.deposit_confirmations > 1 ||
                    exchangedata.attributes.deposit_confirmations ===
                      undefined ||
                    exchangedata.attributes.deposit_confirmations === null
                      ? "s"
                      : ""
                  }`}
                />
                {exchangedata.attributes.deposit_confirmations === 1 && (
                  <div className="error-row" style={{ background: "#12161b" }}>
                    Deposits should be credited once finalized by pre-consensus.
                  </div>
                )}
                {exchangedata.attributes.deposit_confirmations > 1 && (
                  <div className="error-row" style={{ background: "#b95e5e" }}>
                    Deposits should be credited once finalized by pre-consensus.
                  </div>
                )}
                {exchangedata.attributes.deposit_confirmations === null && (
                  <div className="error-row-undefined">
                    Deposits should be credited once finalized by pre-consensus.
                  </div>
                )}

                {/********************************** FEE *****************************************/}

                <DetailsRow
                  type="withdrawal_fee"
                  item={exchangedata.attributes.withdrawal_fee}
                  title={`Withdrawal Fee${
                    exchangedata.attributes.withdrawal_fee !== null
                      ? exchangedata.attributes.withdrawal_fee === 1
                        ? ": " +
                          exchangedata.attributes.withdrawal_fee.toLocaleString() +
                          " bit (XEC)"
                        : ": " +
                          exchangedata.attributes.withdrawal_fee.toLocaleString() +
                          " bits (XEC)"
                      : ""
                  }`}
                />
                {exchangedata.attributes.withdrawal_fee > 100 && (
                  <div
                    className="error-row"
                    style={
                      exchangedata.attributes.withdrawal_fee <= 1000
                        ? { background: "#12161b" }
                        : { background: "#b95e5e" }
                    }
                  >
                    A fee of 5 bits (XEC) covers most eCash transactions. A fee
                    at or below 1000 bits is considered reasonable, with
                    anything at or below 100 bits is considered ideal.
                  </div>
                )}
                {exchangedata.attributes.withdrawal_fee === null && (
                  <div className="error-row-undefined">
                    A fee of 5 bits (XEC) covers most eCash transactions. A fee
                    at or below 1000 bits is considered reasonable, with
                    anything at or below 100 bits is considered ideal.
                  </div>
                )}

                {/********************************** TRADING PAIRS *****************************************/}

                <DetailsRow
                  type="trading_pairs"
                  item={exchangedata.attributes.trading_pairs}
                  title={`Trading Pairs: ${exchangedata.attributes.trading_pairs.join(
                    ", "
                  )}`}
                />
                {exchangedata.attributes.trading_pairs.length <= 1 ? (
                  <div className="error-row" style={{ background: "#12161b" }}>
                    Trading should be available on multiple pairs.
                  </div>
                ) : null}

                {/********************************** DECIMAL *****************************************/}

                <DetailsRow
                  type="decimal"
                  item={exchangedata.attributes.decimal_places}
                  title="Decimal Place"
                />
                {exchangedata.attributes.decimal_places !== 2 ? (
                  exchangedata.attributes.decimal_places !== null ? (
                    <div
                      className="error-row"
                      style={{ background: "#12161b" }}
                    >
                      eCash uses bits (2 decimals), which should be used when
                      trading, depositing, and withdrawing.
                    </div>
                  ) : (
                    <div className="error-row-undefined">
                      eCash uses bits (2 decimals), which should be used when
                      trading, depositing, and withdrawing.
                    </div>
                  )
                ) : null}

                {/* <a
                  className="visit-link"
                  href={exchangedata.attributes.url !== undefined ? exchangedata.attributes.url : ''}
                  target="_blank"
                  rel="noreferrer"
                >
                  {exchangedata.attributes.url !== undefined ? 'Visit' : 'no link'}
                </a> */}
                <div className="score-ctn">
                  <div
                    className="scorebox"
                    style={
                      exchangedata.attributes.score >= 80
                        ? { backgroundColor: "#0671c0" }
                        : exchangedata.attributes.score >= 60
                        ? { backgroundColor: "#005792" }
                        : exchangedata.attributes.score >= 40
                        ? { backgroundColor: "#00426e" }
                        : exchangedata.attributes.score >= 20
                        ? { backgroundColor: "#003253" }
                        : exchangedata.attributes.score >= 0
                        ? { backgroundColor: "#00263e" }
                        : { backgroundColor: "#001d2f" }
                    }
                  >
                    {exchangedata.attributes.score.toFixed()}
                  </div>
                  Total Score
                </div>
              </div>

              <div className="back-btn" onClick={() => navigate(-1)}>
                Back
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ExchangePage;
